module.exports = __webpack_public_path__ + "media/images/design/images/btn_event_cal-f30593dd298bbe854ec205ce0e35bc6b.png";